import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import componentUtil from 'utils/component';
import { appTheme } from 'components/theme';

export default function withAppThemeHOC(Component) {
  const WithAppTheme = (props) => {
    return (
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <Component {...props} />
      </ThemeProvider>
    );
  };
  WithAppTheme.displayName = componentUtil.getDisplayName(
    Component,
    'WithAppTheme'
  );
  return WithAppTheme;
}
